<app-page-content>
<app-doenkids-menu-bar menuBar [showBackButton]="true"></app-doenkids-menu-bar>
<div content>

<app-split-page [leftLabel]="'split_pane.navigation.reviews' | translate" [rightLabel]="'activity.details' | translate" [leftWidth]="40" [independentScroll]="true" *ngVar="(reviews$ | async) as reviews">
  <ng-template #left>
    <div class="left-content">
      <mat-form-field appearance="outline">
        <mat-select [(value)]="selectedStatusOption" (selectionChange)="selectionChange()">
          @for (option of reviewStatusOptions; track option) {
            <mat-option [value]="option.value">
              {{ ('review.status.' + (option.value | lowercase)) | translate }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <card-list *showSpinner="(reviewsLoading$ | async)">
        <ng-container *noContent="!reviews || !(reviews?.length > 0); title: 'review_approval.no_reviews' | translate">
          @for (review of reviews | paginate: (paginationConfig$ | async); track review) {
            <card-list-item
              (click)="selectReview(review)"
              [selected]="review.id === (selectedReview$ | async)?.id"
              [mediaUuid]="review.activity_media_uuid">
              <span>
                {{ (review.average_review_score / 20) | i18n_number: '1.1-1' | async }}
                <mat-icon [style.fontSize.px]="16">star</mat-icon>
              </span>
              <span>{{review.organization_unit_name}}</span>
              <span>{{review.activity_name}}</span>
            </card-list-item>
          }
        </ng-container>
      </card-list>
    </div>
    @if ((paginationConfig$ | async).totalItems > MAX_ITEMS_PER_PAGE) {
      <pagination-controls id="reviewApproval" (pageChange)="paginateReviews($event)"></pagination-controls>
    }
  </ng-template>
  <ng-template #right>
    <div class="flex-1 flex-col right-content">
      @if ((selectedReview$ | async); as selectedReview) {
        <app-review-preview
          [admin]="true"
          [selectedStatusOption]="selectedStatusOption"
          [review]="selectedReview"
          (statusChange)="statusChange()">
        </app-review-preview>
      } @else {
        <h1>{{ 'review_approval.make_selection' | translate }}</h1>
      }

    </div>
  </ng-template>
</app-split-page>

</div>
</app-page-content>
